import React, {useContext, useEffect, useRef, useState} from "react";
import {Cancel, Save} from "@mui/icons-material";
import {AppbarContentContext} from "../../../../commons/routing/appbar/AppbarContentProvider";
import useCreateCourse from "./useCreateCourse";
import AppbarActionButton from "../../../../commons/elements/buttons/AppbarActionButton";
import GeneralEditCourseForm from "../utils/GeneralEditCourseForm";
import {useIntl} from "react-intl";
import LoadingProgressIndication from "../../../../commons/elements/progress/loading/LoadingProgressIndication";

const NewCourseSection = () => {
    // Hook to update the appbar
    const {setCurrentAppbarContent} = useContext(AppbarContentContext)

    // Hook providing the new course functionality
    const {create, saveInProgress, cancel} = useCreateCourse()

    // Reference, which holds will hold the course data according to the current form data
    const editedCourseRef = useRef()

    // Determines if the save button should be enabled.
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(false)

    // Internationalization for simple strings
    const intl = useIntl();

    // Setting the appbar content
    useEffect(() => {
        setCurrentAppbarContent({
            header: intl.formatMessage({id: 'app.courses.new.appbar.header', defaultMessage: 'Create New Course'}),
            description: intl.formatMessage({
                id: 'app.courses.new.appbar.description',
                defaultMessage: 'Compose a new course...'
            }),
            actions: <>
                <AppbarActionButton
                    label={intl.formatMessage({id: 'app.courses.new.appbar.actions.save', defaultMessage: 'Save'})}
                    onClick={() => create(editedCourseRef.current)} icon={<Save/>}
                    disabled={!saveButtonEnabled}/>
                <AppbarActionButton
                    label={intl.formatMessage({id: 'app.courses.new.appbar.actions.cancel', defaultMessage: 'Cancel'})}
                    onClick={() => cancel()} icon={<Cancel/>}/>
            </>,
            progress: saveInProgress
        })
    }, [saveButtonEnabled, saveInProgress])

    if (saveInProgress) {
        return <LoadingProgressIndication
            text={intl.formatMessage({id: 'app.courses.new.save.loading', defaultMessage: 'Creating Course...'})}/>
    }

    return (
        <GeneralEditCourseForm editedCourseRef={editedCourseRef}
                               setSaveButtonEnabled={setSaveButtonEnabled}/>
    );
}

export default NewCourseSection